import { numberFormat } from '../../../utils/formats/formats'
import api from '../../api'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'

const pendingRefills = ({
  sPagina,
  nAsignacionesPagina,
  dDesde,
  dHasta,
  sCentroCosto,
}) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.pendingRefills, {
    params: {
      nPagina: sPagina,
      nAsignacionesPagina,
      sEmpresa,
      dDesde,
      dHasta,
      sCentroCosto,
    },
    headers: { token },
  })
}

const newRecharge = ({
  sEmpresa,
  sCentroCosto,
  sSucursal,
  sTipoRecarga,
  nMontoTotal,
  sFechaProgramacion,
  cEmpleados,
  bNotificarAsignacion = false,
}) => {
  const token = localStorage.getItem('token')
  const filterEmployees = cEmpleados.filter((employee) =>
    employee.nMonto ? numberFormat(employee.nMonto, 'number') > 0 : false,
  )
  return api.post(
    endpoints.new_refills,
    {
      sEmpresa,
      sCentroCosto,
      sSucursal,
      sTipoRecarga,
      nMontoTotal,
      sFechaProgramacion,
      cEmpleados: filterEmployees,
      bNotificarAsignacion,
    },
    { headers: { token } },
  )
}

const caculateRecharge = async ({
  sEmpresa,
  nMonto,
  sBusqueda,
  sSucursal = '',
  sCentroCosto = '',
  nDias = 1,
  sTipoEmpleado,
  sOrderby = '',
  bAsc = true,
}) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.calculate_recharge, {
    params: {
      sEmpresa,
      sSucursal,
      sBusqueda: sBusqueda?.trim() || '',
      sCentroCosto,
      nMonto: Number(nMonto.replace(/\W+/g, '')) || 0,
      nDias,
      sTipoEmpleado: sTipoEmpleado || '',
      sOrderby,
      bAsc,
    },
    headers: { token },
  })
}

const listRefill = async ({
  sEmpresa,
  nPagina,
  nAsignacionesPagina,
  dDesde,
  dHasta,
  sCentroCosto = '',
  sSucursal = '',
  sTipoRecarga = '',
  sTipoAsignacion = '',
  bProgramacionAsignacion = '',
}) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.rechargeList, {
    params: {
      sEmpresa,
      nPagina,
      nAsignacionesPagina,
      dDesde,
      dHasta,
      sCentroCosto,
      sSucursal,
      sTipoRecarga,
      sTipoAsignacion,
      bProgramacionAsignacion,
    },
    headers: { token },
  })
}

const confirmRefill = async (sUsuario, sPASS, sAsignacion) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.confirmRefill,
    { sUsuario, sAsignacion, sPASS },
    { headers: { token } },
  )
}
const declineRefill = async (sUsuario, sAsignacion) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.declineRefill,
    { sUsuario, sAsignacion },
    { headers: { token } },
  )
}

const refillDetail = async (nAsignacion) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.refillDetail, {
    params: { nAsignacion, sEmpresa },
    headers: { token },
  })
}

const validateMassiveNominative = async ({ sucursal, centroCosto, datos }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(
    endpoints.validateMassiveNominative,
    {
      sEmpresa,
      sucursal,
      centroCosto,
      datos,
    },
    { headers: { token } },
  )
}

const refillNoNominativeDocument = () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.noNominativeRefillFile, {
    params: { sEmpresa },
    headers: { token },
  })
}

const sendReportByEmail = ({ sEmail, sFecha }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.reporteRecargaAutomatica, {
    params: { sEmpresa, sFecha, sEmail },
    headers: { token },
  })
}

export default {
  newRecharge,
  caculateRecharge,
  listRefill,
  refillDetail,
  confirmRefill,
  declineRefill,
  pendingRefills,
  validateMassiveNominative,
  refillNoNominativeDocument,
  sendReportByEmail,
}
